import { NotificationCenter } from '@affine/component';
import { DefaultServerService } from '@affine/core/modules/cloud';
import { ServerConfigGate } from '@affine/core/components/providers/server-config-gate';
import { FrameworkScope, useService } from '@toeverything/infra';
import { Outlet } from 'react-router-dom';

import { ServerOfficialWebsiteProvider } from '../../../components/providers/official-website';
import { GlobalDialogs } from '../../dialogs';
import { CustomThemeModifier } from './custom-theme';
import { FindInPagePopup } from './find-in-page/find-in-page-popup';

export const RootWrapper = () => {
  const defaultServerService = useService(DefaultServerService);

  return (
    <FrameworkScope scope={defaultServerService.server.scope}>
      <ServerConfigGate>
        <ServerOfficialWebsiteProvider>
          <GlobalDialogs />
          <NotificationCenter />
          <Outlet />
          <CustomThemeModifier />
          {BUILD_CONFIG.isElectron && <FindInPagePopup />}
        </ServerOfficialWebsiteProvider>
      </ServerConfigGate>
    </FrameworkScope>
  );
};
